import { useQuery } from '@tanstack/react-query';

import { useUtilityContext } from '@change-corgi/core-react/utilityContext';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { useSessionUuid } from '#src/app/shared/hooks/session';
import type { ShareLink } from '#src/app/shared/hooks/share';

import { getPetitionMobileNativeShareLink } from './api';

const QUERY_KEY = 'petition-mobile-native-share-link';

type PetitionMobileNativeShareLinkResult = {
	link: ShareLink | null;
	isLoading: boolean;
};

export function usePetitionMobileNativeShareLink(): PetitionMobileNativeShareLinkResult {
	const {
		data: {
			petition: { id },
		},
	} = usePetitionDetailsPageData();
	const utilityContext = useUtilityContext();
	const sessionUuid = useSessionUuid();

	const { data = null, isLoading } = useQuery({
		queryKey: [QUERY_KEY, { id, sessionUuid }],
		queryFn: async () => getPetitionMobileNativeShareLink({ id, utilityContext }),
		staleTime: Infinity,
	});

	return { link: data, isLoading };
}
